/* eslint-disable i18next/no-literal-string */

import { StyledActionButton } from '../../../styles/table-styles';

export const SupportDetailBot = () => {
    console.log('SupportDetailBot');

    const messages = [
        {
            date: '2023-09-25 09:30:00',
            text: "Hello, I am having issues with the screen share feature. It's not working when I try to share my screen during a live class. Can you help?",
            userName: 'Customer123'
        },
        {
            date: '2023-09-25 09:31:00',
            text: "Hello Customer123, I'm here to help! To begin troubleshooting, could you please tell me if you are receiving any error messages when you attempt to share your screen?",
            userName: 'SupportBot'
        },
        {
            date: '2023-09-25 09:33:00',
            text: "Yes, it says 'Failed to share screen. Please try again.' But trying again doesn't work.",
            userName: 'Customer123'
        },
        {
            date: '2023-09-25 09:34:00',
            text: 'Thank you for sharing that information. It seems like there might be a permissions issue. Could you please check if our virtual classroom software has the necessary permissions to access screen recording on your device? You can usually find these settings under the privacy or security section of your device settings.',
            userName: 'SupportBot'
        },
        {
            date: '2023-09-25 09:36:00',
            text: 'I checked the permissions and it looks like it already has the necessary permissions.',
            userName: 'Customer123'
        },
        {
            date: '2023-09-25 09:37:00',
            text: "Thank you for checking. Let’s try resetting the screen sharing feature. Please go to your account settings within our virtual classroom software, find the screen sharing option, and click on 'Reset'. Then try to share your screen again to see if the issue is resolved.",
            userName: 'SupportBot'
        }
    ];

    return (
        <>
            <h2>{'Troubleshooting Conversation'}</h2>
            {messages.map((message, index) => (
                <div key={index} style={{ position: 'relative', marginBottom: '8px', backgroundColor: message.userName === 'SupportBot' ? '#4739e7' : '#DFDFDF', color: message.userName === 'SupportBot' ? '#ffffff' : '#000000' }}>
                    <div style={{ fontSize: '14px', maxWidth: 'calc(100% - 100px)', padding: '10px' }}>
                        <span style={{ fontWeight: 'bold' }}>{message.userName}</span>: {message.text}
                    </div>
                    <div style={{ position: 'absolute', top: '0px', right: '3px', fontSize: '10px' }}>
                        {message.date}
                    </div>
                </div>
            ))}
            <textarea style={{ width: 'calc(100% - 0px)', height: '200px' }}></textarea>
            <StyledActionButton variant='contained' onClick={() => null}>{'Send Message'}</StyledActionButton>
            <br/>
        </>
    );
};
